import ResourceDetail from "@/src/pages/resource-detail";

export default function BlogDetailPage() {
  return <ResourceDetail type="blog_posts" backTo="/blog" label="Blog" />;
}

